<template>
  <zen-one :showuserinfo="true" :title="'Welcome to ' + $page.props.app_name">
    <z-page class="white--bg mt3 sh2" :title="'Apa Khabar ' + $page.props.auth.user.name + '!'" icon="fal fa-user">

    <w-image
      src="/images/sample/wave2.png"
      
      height="200"
      width="100%"
    >
    </w-image>

    <p class="justify">
    <strong class="primary">{{ $page.props.auth.user.name }}</strong> adalah salah satu daripada watak utama dalam cerita ini. Dia adalah anak murid Wira Utama yang mewarisi  Hikmat <em>TENDANGAN ANGIN PUYUH</em>. Hikmat ini adalah hikmat yang mementingkan kepantasan dan kelincahan gerak tendangan. Sesiapa yang mahir dengan hikmat ini juga secara tidak langsung akan dapat melayangkan dirinya diudara dengan sesuka hatinya
    Hikmat Penjejak Badai mempunyai kepantasan yang tak terhingga.<br /><br />
    </p>
    <p>
    Diantara Hikmat yang dikuasai oleh Penjejak Badai adalah:-<br /><br />
    </p>
    <p>
    <ol class="ml5">
      <li>Tendangan Angin Puyuh</li>
      <li>Badai Lalu Bangunan Runtuh</li>
      <li>Angin Menderu Hujan Mencurah</li>
      <li>Tendangan Keramat Badai</li>
      <li>Angin Kencang Dengan Hujan Lebat</li>
      <li>Gaya Angin Menyapu Sisa Awan</li>
    </ol>
    <br /><br />
    </p>

    <w-card class="white--bg" content-class="pa0">
      <template #title>
        Maklumat Saya
      </template>

        <div class="message-box">
          <w-transition-fade>

            <w-alert
              class="my0 text-light"
              v-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} medan mempunyai ralat di dalam borang ini.

              <ul class="alert alert-danger" v-if="errors && Object.keys(errors).length > 0" v-for="errorf in errors">
                  <li v-for="error in errorf">{{error}}</li>
              </ul>
            </w-alert>
          </w-transition-fade>
        </div>

        <w-form
          class="px8 pt2 pb12"
          v-model="form.valid"
          v-model:errors-count="form.errorsCount"
          @validate="onValidate"
          @success="onSuccess"
          >

          <z-input
            required
            name="nama"
            label="Nama Penuh"
            v-model="data.nama"
            :validators="[validators.required]">
          </z-input>

          <z-input
            class="mt3"
            required
            name="samaran"
            label="Nama Samaran"
            ref="samaran"
            v-model="data.samaran"
            :validators="[validators.required]">
          </z-input>

          <z-input
            class="mt3"
            disabled
            required
            label="ID Pengguna"
            v-model="data.userid"
            :validators="[validators.required]">
          </z-input>

          <w-flex class="mt4" wrap align-center justify-end>
            <w-checkbox
              required
              :validators="[validators.consent]">
              Saya Setuju
            </w-checkbox>

            <div class="spacer" />

            <w-button
              class="my1 mr2"
              bg-color="warning"
              type="reset"
              @click="form.submitted = form.sent = false">
              Reset
            </w-button>

            <w-button
              class="my1"
              type="submit"
              :disabled="form.valid === false"
              :loading="form.submitted && !form.sent">
              Hantar
            </w-button>
          </w-flex>
        </w-form>

        <w-notification
          v-model="form.sent"
          success
          transition="bounce"
          absolute
          plain
          round
          bottom
          >
          Maklumat berjaya disimpan
        </w-notification>
      </w-card>
    </z-page>
  </zen-one>
</template>

<script>
export default {
data() {
    return {
  errors: [],
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  data: {
    nama: '',
    samaran: '',
    userid: ''
  },
  validators: {
    required: value => !!value || 'Medan ini adalah wajib',
    consent: value => !!value || 'Anda mesti setuju'
  },
  crumbs: [
    { label: this.$page.props.app_name, route: '/sitemap' },
    { label: 'Home', route: '/' },
    { label: 'Welcome', route: '/w-breadcrumbs' }
  ],
}},
methods: {
  onSuccess () {
    // this.$waveui.notify('Dropping table...', 'error', 3000)
    this.$zcomm.post(route('updateuser'),this.data)
    .then(res => {
      this.data = res
      this.form.sent = true
    })
    .catch(err => {
      this.form.valid = false
      this.form.submitted = false
      this.$page.props.errors = err.response.data.errors
      this.errors = err.response.data.errors
      this.form.errorsCount = this.errors ? Object.keys(this.errors).length : 0
    })
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
}
}

</script>

<style>


</style>